// Material
import { Box, Divider, ListItemButton, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
  width: '100%',
  minHeight: '66px',

  margin: 0,
  padding: '8px 15px',

  outline: 'none',
  justifyContent: 'space-between',
  textAlign: 'inherit',
  backgroundColor: theme.palette.white,
  flexGrow: 0,
}))

const StyledDivider = styled(Divider)`
  &:last-child {
    display: none;
  }
`

interface Props {
  primaryText: string
  secondaryText: string
  icon: JSX.Element
  onClick: () => any
}

export function OptionWithTextItem({
  primaryText,
  secondaryText,
  icon,
  onClick,
}: Props) {
  return (
    <>
      <StyledListItemButton onClick={onClick}>
        <Box>
          <Typography
            gutterBottom
            variant="caption1"
            component="div"
            color="secondary"
            sx={{ marginTop: '5px' }}
          >
            {primaryText}
          </Typography>
          <Typography
            dir="auto"
            variant="body2"
            sx={{ margin: '5px 0' }}
            color="semiBlack"
          >
            {secondaryText}
          </Typography>
        </Box>
        {icon}
      </StyledListItemButton>
      <StyledDivider />
    </>
  )
}
